import { ExtendedIntegration, IntegrationCredentials } from "@supernova-studio/model";
import { DTOIntegration, DTOIntegrationCredentials } from "../../dto";

export function integrationToDto(integration: ExtendedIntegration): DTOIntegration {
  return {
    id: integration.id,
    workspaceId: integration.workspaceId,
    type: integration.type,
    createdAt: integration.createdAt,
    integrationCredentials: integration.integrationCredentials?.map(integrationCredentialToDto),
    integrationDesignSystems: integration.integrationDesignSystems ?? undefined,
  };
}

export function integrationCredentialToDto(credential: IntegrationCredentials): DTOIntegrationCredentials {
  return {
    id: credential.id,

    createdAt: credential.createdAt,
    refreshedAt: credential.refreshedAt,
    expiresAt: credential.expiresAt,

    integrationId: credential.integrationId,
    type: credential.type,

    userId: credential.userId,
    user: credential.user,

    customUrl: credential.customUrl,

    profile: credential.profile,
    tokenName: credential.tokenName,
    username: credential.username,
    appInstallationId: credential.appInstallationId,
    state: credential.state,
  };
}
